"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SampleDataSubheading_1 = __importDefault(require("../../sample/SampleDataSubheading"));
const AccountSpecifications_1 = __importDefault(require("../../sample/AccountSpecifications"));
function Subheading({ actionNounInLowercase, authTitle, hasServiceAuthType, serviceKey, serviceName, serviceBuiltIn, }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        "Here's an example ",
        actionNounInLowercase,
        ".",
        serviceBuiltIn ? (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            "If you want to use real data, select Test trigger.")) : (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            "If you want to use real data, create one in your",
            ' ',
            react_1.default.createElement(AccountSpecifications_1.default, { authTitle: authTitle, hasServiceAuthType: hasServiceAuthType, serviceKey: serviceKey, serviceName: serviceName }),
            ' ',
            "and test your trigger again."))));
}
function NoSamplesFoundSubheading(props) {
    const { actionNounInLowercase } = props;
    return (react_1.default.createElement(SampleDataSubheading_1.default, { emoji: {
            label: 'magnifying glass',
            symbol: '🔍',
        }, heading: `No ${actionNounInLowercase} found`, subtextComponent: react_1.default.createElement(Subheading, Object.assign({}, props)) }));
}
exports.default = NoSamplesFoundSubheading;
